import CommonAutoComplete from "./CommonAutoComplete";

export default CommonAutoComplete;
